@if ((!offer() || isLoadingView) && offerFound) {
  <div style="text-align: center;" id="offerSpinner" class="col-12 col-md-8 text-center offer-detail__spinner">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!offerFound) {
  <div [innerHTML]="translationService.getTranslation('offer_not_found')" data-cy="offer-not-found"
       class="offer-detail__not-found"></div>
}

@if (offer() && !isLoadingView) {
  <div class="offerContainer offer-detail__container" #offerContainer (window:resize)="onResize()">
    <app-general-errors [errors]="errorsArr" class="offer-detail__errors"></app-general-errors>

        @if (isDigitalOffer()) {
         <app-digital-offer
           [offer]="offer()"
           [stepperOrientation]="stepperOrientation"
           [isAuthenticated]="isAuthenticated"
           [isEditable]="isEditable"
           [hideLoginBox]="hideLoginBox"
           [isWinback]="isWinback"
           [currentProductAlreadyOrdered]="currentProductAlreadyOrdered()"
           [userData]="userData()">
         </app-digital-offer>
        } @else {
          <app-print-offer
            [offer]="offer()"
            [stepperOrientation]="stepperOrientation"
            [isAuthenticated]="isAuthenticated"
            [isEditable]="isEditable"
            [hideLoginBox]="hideLoginBox"
            [isWinback]="isWinback"
            [currentProductAlreadyOrdered]="currentProductAlreadyOrdered()"
            [userData]="userData()">
          </app-print-offer>
        }
      </div>
}

<!-- Navigation -->
<div class="mt-3 float-end offer-detail__back-to-overview">
  @if (showBackToOverviewButton && !isLoadingView) {
    <button mat-raised-button
            (click)="backToOverview()"
            [innerHTML]="translationService.getTranslation('button_back_to_overview')">
    </button>
  }
</div>
